// https://vuex.vuejs.org/en/getters.html

export default {
  getPending: (state) => state.pending,
};
